import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "notif-close" }, null, -1)
const _hoisted_2 = { class: "notif-wrap__title" }
const _hoisted_3 = {
  key: 0,
  class: "notif-wrap__type"
}
const _hoisted_4 = {
  key: 1,
  class: "notif-wrap__type"
}
const _hoisted_5 = {
  key: 2,
  class: "notif-wrap__type"
}
const _hoisted_6 = {
  key: 3,
  class: "notif-wrap__type"
}
const _hoisted_7 = ["innerHTML"]

import { watch } from "vue";
import { useUserInitials } from "@/composition/user/useUserInitials";
import { useUserFullName } from "@/composition/user/useUserFullName";
import { useChat } from "@/composition/chat/useChat";
import { useEventsBus } from "@/composition/event/useEventBus";
import { EventsEnum } from "@/utils/enum/general/eventsEnum";
import DefaultUserAvatar from "@/components/common/other/DefaultUserAvatar.vue";
import ChatGifIcon from "@/components/icons/ChatGifIcon.vue";
import ChatAudioIcon from "@/components/icons/ChatAudioIcon.vue";
import ChatImageIcon from "@/components/icons/ChatImageIcon.vue";
import ChatVideoIcon from "@/components/icons/ChatVideoIcon.vue";
import { ContentMediaTypeEnum } from "@/utils/enum/chat/message/contentMediaTypeEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatNotification',
  props: {
    notification: null
  },
  setup(__props: any) {

const props = __props as {
  notification: {
    text: string;
    sentAt: string;
    chatRoomId: string;
    userAvatar: string | null;
    userName: string | null;
    userSurname: string | null;
    userNickname: string;
    contentMediaType: ContentMediaTypeEnum;
  };
}



const { currentChat } = useChat();
const { emit } = useEventsBus();
const { goToChat } = useChat();

watch(
  () => currentChat.value,
  (value) => {
    if (value?.chatRoomId === props.notification.chatRoomId) {
      emit(EventsEnum.USER_CHANGED_CHAT, { chatRoomId: value.chatRoomId });
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "notif-icon",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goToChat)(__props.notification.chatRoomId)))
    }, [
      _createVNode(DefaultUserAvatar, {
        avatar: __props.notification.userAvatar,
        "disable-lazy-loading": true,
        "user-initials": 
        _unref(useUserInitials)(
          __props.notification.userName,
          __props.notification.userSurname,
          __props.notification.userNickname
        )
      
      }, null, 8, ["avatar", "user-initials"])
    ]),
    _createElementVNode("div", {
      class: "notif-wrap",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToChat)(__props.notification.chatRoomId)))
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(useUserFullName)(
          __props.notification.userName,
          __props.notification.userSurname,
          __props.notification.userNickname
        )), 1),
      (__props.notification.contentMediaType !== _unref(ContentMediaTypeEnum).NONE)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (__props.notification.contentMediaType === _unref(ContentMediaTypeEnum).AUDIO)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(ChatAudioIcon),
                  _createTextVNode(" Audio ")
                ]))
              : _createCommentVNode("", true),
            (__props.notification.contentMediaType === _unref(ContentMediaTypeEnum).IMAGE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(ChatImageIcon),
                  _createTextVNode(" Image ")
                ]))
              : _createCommentVNode("", true),
            (__props.notification.contentMediaType === _unref(ContentMediaTypeEnum).GIF)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(ChatGifIcon),
                  _createTextVNode(" Gif ")
                ]))
              : _createCommentVNode("", true),
            (__props.notification.contentMediaType === _unref(ContentMediaTypeEnum).VIDEO)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(ChatVideoIcon),
                  _createTextVNode(" Video ")
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "notif-wrap__text",
            innerHTML: __props.notification.text
          }, null, 8, _hoisted_7))
    ])
  ], 64))
}
}

})